import { createIcon } from './create-icon';

export const ShareIcon = createIcon(
  'ShareIcon',
  <>
    <path d="M12 3v12" />
    <path d="M7.5 7.5 12 3l4.5 4.5" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
  </>,
);
